// PURELY BELLA accessibility fixes — draft theme (Sept 19 2026)
// Non-destructive DOM patches applied after load, so screen readers and
// automated audits see corrected labels without editing large Liquid files.
(function () {
  'use strict';

  var run = function () {
    try {
      // 1) Remove empty <h2 class="word--break"> (decorative spacer output when
      //    a section title setting is left blank). Empty headings break the
      //    heading map; delete rather than hide so AT skips them entirely.
      document.querySelectorAll('h2.word--break, h3.word--break, h4.word--break').forEach(function (h) {
        if (!h.textContent.trim() && !h.querySelector('img,svg')) {
          h.remove();
        }
      });

      // 2) Product page: promote H1 hierarchy — recast H4 sub-heading as a
      //    paragraph. The visual style (.sub-heading) is preserved via CSS.
      document.querySelectorAll('h4.sub-heading').forEach(function (h) {
        var p = document.createElement('p');
        p.className = h.className + ' pb-sub-heading-p';
        p.innerHTML = h.innerHTML;
        // preserve any inline styles
        if (h.getAttribute('style')) p.setAttribute('style', h.getAttribute('style'));
        h.parentNode.replaceChild(p, h);
      });

      // 3) Icon images with the generic alt="Icon" — rewrite from the nearest
      //    text label so the announcement is meaningful. Falls back to alt=""
      //    (decorative) if no label is found nearby.
      document.querySelectorAll('img[alt="Icon"], img[alt="icon"]').forEach(function (img) {
        var label = '';
        var container = img.closest('.icon_item, .icon-item, .icon-wrapper, .icon_item-wrapper');
        if (container) {
          // Look for a title, span, or text sibling
          var t = container.querySelector('.icon_item-title, .icon-title, .icon_item-text, h3, h4, h5, p, span');
          if (t && t.textContent.trim()) label = t.textContent.trim();
        }
        if (!label) {
          // Look at parent block for a paragraph
          var parent = img.parentElement;
          for (var i = 0; i < 3 && parent; i++) {
            var t2 = parent.querySelector('p, span, h3, h4');
            if (t2 && t2.textContent.trim() && !t2.contains(img)) {
              label = t2.textContent.trim();
              break;
            }
            parent = parent.parentElement;
          }
        }
        if (label) {
          img.setAttribute('alt', label);
        } else {
          // decorative — leave for screen readers to skip
          img.setAttribute('alt', '');
          img.setAttribute('role', 'presentation');
        }
      });

      // 4) Collection page: promote the first visible collection heading to
      //    an accessible H1 without breaking styling. Add a visually hidden
      //    H1 at the top of the main content when none exists.
      if (window.location.pathname.startsWith('/collections/') && !document.querySelector('main h1')) {
        var main = document.querySelector('main');
        if (main) {
          var visH2 = main.querySelector('h2');
          var title = (visH2 && visH2.textContent.trim()) || (document.title || 'Collection').split('|')[0].trim();
          var h1 = document.createElement('h1');
          h1.className = 'pb-sr-only';
          h1.textContent = title;
          main.insertBefore(h1, main.firstChild);
        }
      }

      // 5) Header account link: add aria-label if missing so the icon-only
      //    button announces its purpose.
      document.querySelectorAll('a[href="/account"], a[href^="/account?"], a[href$="/account"]').forEach(function (a) {
        if (!a.getAttribute('aria-label') && !a.textContent.trim()) {
          a.setAttribute('aria-label', 'Account');
        }
      });

      // 6) Cart icon-only trigger: add aria-label
      document.querySelectorAll('a[href="/cart"], a[href^="/cart?"], button.cart-trigger').forEach(function (el) {
        if (!el.getAttribute('aria-label') && !el.textContent.trim()) {
          el.setAttribute('aria-label', 'Cart');
        }
      });

      // 7) Search icon-only trigger
      document.querySelectorAll('button.search-trigger, a[href="/search"]').forEach(function (el) {
        if (!el.getAttribute('aria-label') && !el.textContent.trim()) {
          el.setAttribute('aria-label', 'Search');
        }
      });
    } catch (e) {
      if (window.console && console.warn) console.warn('[PB a11y]', e);
    }
  };

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(run, 60);
  } else {
    document.addEventListener('DOMContentLoaded', run);
  }
  // Re-run after Klaviyo/section reloads so late-injected DOM is patched too.
  window.addEventListener('load', function () { setTimeout(run, 300); setTimeout(run, 1200); });
})();
